import { uic } from '../utils'

export const Skeleton = uic('div', { baseClass: 'rounded-md bg-primary/10 animate-pulse' })
